// ModalToast.jsx
const ModalToast = ({ message, type, onClose }) => {
    
  return (
    <div className="modal-toast-backdrop">
      <div className={`modal-toast modal-${type}`}>
        <div className={`text-sm ${type=="error"?"text-red-500":"text-slate-700"} `}>{message}</div>
        <button className="border-1 py-1 mt-5 px-5 bg-blue-700 text-xs text-white" onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default ModalToast;
